<!--
 * @Author: monai
 * @Date: 2021-02-02 11:00:53
 * @LastEditors: yexiu
 * @LastEditTime: 2024-05-29 11:09:55
-->
<template>
	<transition name='fade'>
		<div class='toast_warp' v-if="visible">
			<div class='toast_text' :style="<any>style" v-html="text"></div>
		</div>
	</transition>
</template>
<script lang="ts">
	import toast from './toast';
	export default toast;
</script>
<style lang='scss' scoped>
	.toast_warp{
		position: fixed;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0,0,0,0.58);
		z-index: 500;
		left: 0;
		top: 0;
		.toast_text{
			position: fixed;
			width: 40vw;
			min-height: 10vw;
			background-color: rgba(0,0,0,0.8);
			z-index: 10;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			text-align: center;
			line-height: 10vw;
			font-size: 4vw;
			color: #fff;
			border-radius: 1vw;
			transition: all 0.2s;
		}
	}

	.fade-enter-active, .fade-leave-active {
		transition: opacity 0.5s ease;
	}

	.fade-enter-from, .fade-leave-to {
		opacity: 0;
	}
</style>
